import { render, staticRenderFns } from "./ModalTestRide.vue?vue&type=template&id=52653440&"
import script from "./ModalTestRide.vue?vue&type=script&lang=js&"
export * from "./ModalTestRide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports